import * as React from 'react';
import {Controller} from "react-hook-form";
import Form from "react-bootstrap/Form";

export const CheckboxFormat = ({control, name, label, type, errors, onChange}) => {
    const handleCheckbox = (value) => {
        console.log(value)
    }
    return (
        <Form.Group controlId="formCheckbox">
            <Controller
                name={name}
                className="fs-4 fw-bold"
                control={control}
                defaultValue={false}
                render={({field}) => <Form.Check
                    type="checkbox"
                    {...field}
                    checked={!!field.value}
                    label={label}
                    // checked={field.value}
                    onChange={(e) => {
                        field.onChange(e)
                        if (onChange) {
                            onChange(e)
                        }
                    }}
                />}
            />
        </Form.Group>
    );
};

